import { useCallback, useEffect, useState } from "react";

/** Which of the two texts the client asked for. */
export type GridV2FaqAndTermsTopic = "faq" | "terms";

export interface GridV2FaqAndTermsDialogState {
  topic: GridV2FaqAndTermsTopic | null;
  isOpen: boolean;
  open: (topic: GridV2FaqAndTermsTopic) => void;
  close: () => void;
}

/**
 * Mobile only: the FAQ / Terms rows open a sheet stacked over the modal that
 * holds them. The modal owns this state (not the rows) because the dialog
 * shell unmounts its content while the sheet is up, and passes
 * `open={open && !isOpen}` to its own Dialog: pause while the sheet shows,
 * resume when it closes. `hostOpen` is the modal's own `open` prop: when the
 * host is closed from outside while the sheet is up, the sheet goes too.
 */
export const useGridV2FaqAndTermsDialog = (
  hostOpen: boolean
): GridV2FaqAndTermsDialogState => {
  const [topic, setTopic] = useState<GridV2FaqAndTermsTopic | null>(null);
  useEffect(() => {
    if (!hostOpen) {
      setTopic(null);
    }
  }, [hostOpen]);
  const open = useCallback(
    (next: GridV2FaqAndTermsTopic) => setTopic(next),
    []
  );
  const close = useCallback(() => setTopic(null), []);
  return { topic, isOpen: topic != null, open, close };
};
